import script from "./OrderComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderComplete.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__